import { Box, Typography } from '@mui/material';
import Info from 'components/Info/Info';
import { useGame } from 'contexts/Game/Game';

export default function AllocationWarning() {

    const game = useGame();
    const remaining = Math.round((1 - game.entities.ants.allocation) * 100);

    if (!game.unlocks.portfolioTool || !remaining) {
        return null;
    }

    return <Box alignItems="center" color="white" display="flex">
        <Typography>
            <b>{remaining}%</b> Portfolio unused
        </Typography>
        <Info popupName="portfolioAllocationInfo" />
    </Box>;

}